import {
  Component,
  HostBinding,
  OnInit,
  OnDestroy,
  Inject
} from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import {
  WebsocketGatewayService,
  ENVIRONMENT_CONFIG,
  EnvironmentConfig
} from '@ipreo/northstar';
import { MMDReads } from '../../../models/mmd-read';
import { MMDService } from '../../../services/mmd.service';
import { MarketDrawerRootReducerState } from '../../../state/reducer';
import { MMDLoadSuccessAction } from '../../../state/mmd/actions';
import { getLiveState, getMMDDataState } from '../../../state/reducer';

@Component({
  selector: 'muni-gameday-market-drawer-mmd',
  templateUrl: './mmd.template.html',
  styleUrls: ['./mmd.styles.scss'],
  standalone: false,
})
export class MMDComponent implements OnInit, OnDestroy {
  @HostBinding('class.marketDrawerSection')
  public section = true;

  public readonly data: Observable<MMDReads> = this.store.pipe(
    select(getMMDDataState),
    distinctUntilChanged()
  );
  public readonly live: Observable<boolean> = this.store.pipe(
    select(getLiveState),
    distinctUntilChanged()
  );

  private liveSubscription: Subscription;
  private env: string;

  constructor(
    private store: Store<MarketDrawerRootReducerState>,
    private wsgService: WebsocketGatewayService,
    private mmdService: MMDService,
    @Inject(ENVIRONMENT_CONFIG) config: EnvironmentConfig
  ) {
    this.env = config.northstar.env;
  }

  public ngOnInit(): void {
    this.connectToChannel();
  }

  public ngOnDestroy(): void {
    this.liveSubscription.unsubscribe();
  }

  private connectToChannel(): void {
    this.liveSubscription = this.wsgService
      .subscribe(`munis-mmd-reads-${this.env}`)
      .subscribe((event: any) => {
        const rawReads = event.reads[0];

        if (rawReads) {
          const reads = this.mmdService.mmdReadsToViewModel(event.reads[0]);
          this.store.dispatch(new MMDLoadSuccessAction(reads));
        }
      });
  }
}
